var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReupload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#BA4E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8906 7.59375C16.0273 7.73047 16.0273 7.92188 15.8906 8.05859L15.6445 8.30469C15.5352 8.41406 15.3164 8.41406 15.1797 8.30469L13.4297 6.52734V18.0938C13.4297 18.4766 13.1289 18.75 12.7734 18.75H9.32812C9.02734 18.75 8.86328 18.4219 9.08203 18.2031L9.41016 17.875C9.46484 17.8203 9.57422 17.7656 9.65625 17.7656H12.4453V6.52734L10.668 8.30469C10.5312 8.41406 10.3125 8.41406 10.2031 8.30469L9.95703 8.05859C9.82031 7.92188 9.82031 7.73047 9.95703 7.59375L12.6914 4.85938C12.8281 4.72266 13.0195 4.72266 13.1562 4.85938L15.8906 7.59375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReupload);
export default __webpack_public_path__ + "static/media/reupload.9dd44e8b298c2a8d57e9e4c1486b9d29.svg";
export { ForwardRef as ReactComponent };